import { defineStore } from 'pinia';
import { onUnmounted, ref, watch, type ComputedRef, type Ref } from 'vue';
import { usePiniaRefStore } from '../composables/usePiniaRefStore';

export interface LocalScannerSettings {
  keyPressDelayThreshold: number;
}

export const useLocalSettingsStore = defineStore(
  'local-settings',
  () => {
    const localScannerSettings = ref<LocalScannerSettings>({
      keyPressDelayThreshold: 50,
    });

    return {
      localScannerSettings,
    };
  },
  { persist: true },
);

export const useLocalSettings = () => {
  const store = usePiniaRefStore(useLocalSettingsStore());

  return store;
};
